/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of PrintablesList
 * Alfapeople -Customisation object -For Print page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface IPrint {
  printHeading?: string;
  imageUrl?: string;
  textDescription?: string;
}
/**
 *
 * Print component
 * @extends Component
 */
export class Print extends Component {
  private readonly printPage: IPrint = {
    printHeading: 'Earth Day Unprintable',
    imageUrl:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1C',
    textDescription:
      'Earth Day Unprintable - 10 Eco-Friendly Tips<br/>A cleaner, greener planet is good for everyone, even for people who aren’t born yet! It’s true, when we all do our part to preserve the planet, the Earth thanks us by giving us cleaner water to drink and fresh air to breathe. Sounds pretty good, right? So, on Earth Day – and every day! – let’s follow these 10 ideas.<br/><br/>1. Don’t leave the water running while brushing your teeth.<br/>2. Shut off game systems when you’re done playing.<br/>3. Done watching TV? Be sure to turn it off.<br/>4. Turn off the lights when you leave a room.<br/>5. Check faucets to see if they’re dripping. Tell a parent if they are.<br/>6. Donate the clothes you outgrow.<br/>7. Plant a tree or a garden with your family.<br/>8. Get more in touch with nature – take a hike!<br/>9. Collect rain water and use it to water plants<br/>10. Use old shoeboxes to store baseball cards, crafts and more<br/><br/><br/>BONUS IDEA:Reuse items around your house for crafts & games!',
  };
  public render(): JSX.Element | null {
    return (
      <div className='row'>
        <div className='col-lg-12 col-md-12'>
          <h1 className='print-heading'>{this.printPage.printHeading}</h1>
        </div>
        <div className='col-lg-12 col-md-12'>
          <div className='printContainer'>
            <img
              className='img-responsive'
              src={this.printPage.imageUrl}
              alt={this.printPage.printHeading}
            />
            <p className='print-description'>
              {ReactHtmlParser(this.printPage.textDescription)}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Print;
